import { Component, OnInit, ViewChild } from "@angular/core";
import { EmployeeService } from "../../shared/service/employee.service";
import { MatTableDataSource } from "@angular/material";
import { WinHRPage } from "../../shared/models/WinHRPage";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { WinHRPagesUserMapping } from "../../shared/models/WinHRPagesUserMapping ";
import { ToastrService } from "ngx-toastr";

import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../shared/service/user.service";
import { isNullOrUndefined } from "util";
import { isNull } from "@angular/compiler/src/output/output_ast";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-hr-add-permission",
  templateUrl: "./hr-add-permission.component.html",
  styleUrls: ["./hr-add-permission.component.css"],
})
export class HrAddPermissionComponent implements OnInit {
  empList: any[] = [];
  winHRList: any[] = [];
  error: any;
  dataSourceFTE: any;
  employeeId: FormControl;
  permissionslist: WinHRPagesUserMapping[] = [];
  emp: WinHRPagesUserMapping;
  EmployeeCode: any;
  LoginEmpCode: any;
  empCode: any;
  empName: any;
  gettingBasicDet: BasicEmployeeDetails;
  filteredList: any;
  empForm: FormGroup;
  constructor(
    private userService: UserService,
    private empsvc: EmployeeService,
    public toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    this.dataSourceFTE = new MatTableDataSource();
  }
  displayedColumns: string[] = [
    "Pages",
    "Add",
    "Update",
    "Delete",
    "All Permissions",
    "ReadOnly",
  ];

  ngOnInit() {
    //get the employee code from url
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
    });
    this.LoginEmpCode = this.userService.getEmpCode();
    if (!isNullOrUndefined(this.empCode)) this.GetWinHRUserMappings();
    else {
      (this.employeeId = new FormControl()), this.getHRPages();
      this.getEmployeeList();
    }
    this.dataSourceFTE = new MatTableDataSource();
  }

  getHRPages() {
    this.empsvc.getAllHRPages().subscribe(
      (data: WinHRPage[]) => {
        if (data != null && data.length > 0) {
          if (isNullOrUndefined(this.empCode)) {
            for (var i = 0; i < data.length; i++) {
              this.permissionslist[i] = new WinHRPagesUserMapping();
              this.permissionslist[i].AppPageID = data[i].ID;
              this.permissionslist[i].AppPageName = data[i].Name;
            }
          } else {
            data.forEach((item) => {
              let element = this.winHRList.filter(
                (x) => x.AppPageID == item.ID
              )[0];
              if (element != null) {
                element.AppPageName = item.Name;
                this.permissionslist.push(element);
              } else {
                element = new WinHRPagesUserMapping();
                element.EmpCode = this.empCode;
                element.AppPageID = item.ID;
                element.AppPageName = item.Name;
                this.permissionslist.push(element);
              }
            });
          }
        }
        this.dataSourceFTE.data = this.permissionslist;
      },
      (error) => (this.error = error)
    );
  }

  getBasicEmployeeByCode(empCode) {
    if (empCode != null) {
      this.empsvc.getBasicEmployeeById(empCode).subscribe((data: any) => {
        this.gettingBasicDet = data;
        this.userService
          .getEmployeeUserInformation(this.gettingBasicDet.Email)
          .subscribe((permission: any) => {
            if (permission != null && permission.permissions != null) {
              permission.permissions = permission.permissions.filter(
                (per) => per.Menu !== "Insurance" && per.Menu !== "MyProfile" && per.Menu !== "MonthClose" && (per.Menu === "Offboarding" && per.Name !== 'Offboarding-list')
              );
              if (
                permission.permissions != null &&
                permission.permissions.length > 0
              ) {
                alert("Permission exists");
                this.EmployeeCode = null;
              }
            }
          });
      });
    }
    //return this.gettingBasicDet;
  }

  getEmployeeList() {
    this.empsvc.getAllEmployees().subscribe(
      (data: any[]) => {
        if (!isNullOrUndefined(this.empCode))
          this.empName = data.filter(
            (x) => x.EmpCode == this.empCode
          )[0].FirstName;
        else this.empList = data;
        this.filteredList = this.empList;
      },
      (error) => (this.error = error)
    );
  }

  changeEmpCode(event) {
    var id = event.option.value.split("-");
    for (var i = 0; i < this.permissionslist.length; i++) {
      this.permissionslist[i].EmpCode = id[0];
      this.permissionslist[i].UpdatedBy = this.LoginEmpCode;
    }
    this.getBasicEmployeeByCode(id[0]);
  }
  GetWinHRUserMappings() {
    this.empsvc.GetHRWinHRPages(this.empCode).subscribe(
      (data) => {
        this.winHRList = data;
        this.getHRPages();
        this.getEmployeeList();
      },
      (error) => this.toastr.warning(error)
    );
  }

  SaveEmployeePermissions() {
    if (isNullOrUndefined(this.empCode) && this.employeeId.invalid) {
      this.toastr.warning("Employee Code is required");
      return;
    }
    var list = this.permissionslist;
    list.forEach((item) => {
      if (
        (item.AddingPermission == null || item.AddingPermission == false) &&
        (item.EditingPermission == null || item.EditingPermission == false) &&
        (item.DeletingPermission == null || item.DeletingPermission == false) &&
        (item.HasFullAccess == null || item.HasFullAccess == false) &&
        (item.ReadOnlyPermission == null || item.ReadOnlyPermission == false)
      ) {
        this.permissionslist = this.permissionslist.filter(function (itm) {
          return itm !== item;
        });
      }
    });
    for (var i = 0; i < this.permissionslist.length; i++) {
      this.permissionslist[i].UpdatedBy = this.LoginEmpCode;
      if (isNullOrUndefined(this.empCode)) {
        var id = this.EmployeeCode.split("-");
        this.permissionslist[i].EmpCode = id[0];
      }
    }
    this.empsvc.SaveEmployeePermissions(this.permissionslist).subscribe(
      (data: any) => {
        if (data.ErrorType == "Exception") {
          this.toastr.warning(data.ErrorMsg);
        } else {
          this.toastr.success("Saved Successfully");
          this.router.navigateByUrl("/Permissions");
        }
      },
      (error) => this.toastr.warning(error)
    );
  }
  Cancel() {
    this.router.navigateByUrl("/Permissions");
  }

  doFilter() {
    if (!isNullOrUndefined(this.EmployeeCode) && this.EmployeeCode != "") {
      this.filteredList = this.filter(this.empList);
    }
  }
  filter(values) {
    return values.filter(
      (value) =>
        (value.FirstName != "" &&
          value.FirstName != null &&
          this.removeExtraSpaces(value.FirstName.toLowerCase()).includes(
            this.removeExtraSpaces(this.EmployeeCode.toLowerCase())
          )) ||
        value.EmpCode.toString().includes(this.EmployeeCode.toLowerCase())
    );
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }

  //isPermissionDisabled(i: number, permissionType: string): boolean {
  //  if (i === 7) {
  //    if (permissionType === 'HasFullAccess') {
  //      return this.permissionslist[i]!.ReadOnlyPermission;
  //    } else if (permissionType === 'ReadOnlyPermission') {
  //      return this.permissionslist[i]!.HasFullAccess;
  //    }
  //  }
  //  return false;
  //}

  onPermissionChange(i: number, permissionType: string, element: any): void {
    if (i === 7) {
      if (permissionType === "HasFullAccess") {
        element.ReadOnlyPermission = false;
      } else if (permissionType === "ReadOnlyPermission") {
        element.HasFullAccess = false;
      }
    }
  }
}
